"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[86337],{

/***/ 94526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49288);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background: unset !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: none;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  border: none;\n  cursor: auto;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var OptionsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-773c3636-0"
})(_templateObject());
var OptionRender = function(options) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(OptionsWrapper, {
        children: options
    });
};
var AutoComplete = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        filterOption: false,
        dropdownStyle: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            border: "1px solid ".concat(_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro),
            boxShadow: "unset",
            minWidth: "260px",
            width: "auto"
        }, props.dropdownStyles),
        dropdownRender: props.dropdownRender || OptionRender,
        width: props.width || "100%",
        bordered: props.bordered || false
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-773c3636-1"
})(_templateObject3(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var bordered = param.bordered;
    return bordered && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1());
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (AutoComplete);


/***/ }),

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71577);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: inherit;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: none;\n    border: none;\n    box-shadow: none;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: unset;\n    color: ",
        ";\n    cursor: not-allowed;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n      :hover {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      :hover {\n        transition: 0.2s ease-in;\n        cursor: pointer;\n        background-color: ",
        ";\n        color: ",
        ";\n        border: 1px solid ",
        ";\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: 'ProximaNovaRg';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  font-size: ",
        ";\n\n  ",
        "\n  ",
        ";\n\n  :focus,\n  :hover {\n    ",
        "\n  }\n\n  [disabled] {\n    color: ",
        " !important;\n    background-color: ",
        " !important;\n  }\n\n  ::after {\n    content: unset;\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ::after {\n    content: unset;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var buttonTheme = {
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary),
    secondary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    facebook: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    trading: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    default: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro),
    borderless: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject6()),
    muted: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].suvaGrey */ .Z.suvaGrey, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light)
};
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: props.type || "default",
        margin: props.margin || "unset",
        height: props.height || "auto",
        radius: props.radius || "2px",
        isHoverable: props.isHoverable || false,
        width: props.width,
        fontSize: props.fontSize || "14px"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-3738f451-0"
})(_templateObject11(), function(param) {
    var radius = param.radius;
    return radius;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, function(param) {
    var key = param.color;
    return _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject8(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit", _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit");
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].midgray */ .Z.midgray, function(param) {
    var isHoverable = param.isHoverable;
    return isHoverable && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject9(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro);
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject10(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 48253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* eslint-disable react/jsx-props-no-spreading */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  & > div {\n    display: ",
        ";\n    width: 5px;\n    height: 5px;\n    margin: 2px;\n    border-radius: 50%;\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    shouldForwardProp: function(props) {
        return ![
            "vertical"
        ].includes(props);
    }
}).attrs(function(props) {
    return {
        vertical: props.vertical
    };
}).withConfig({
    componentId: "sc-fadbb486-0"
})(_templateObject(), function(param) {
    var vertical = param.vertical;
    return vertical ? "block" : "inline-block";
}, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highgray */ .Z.highgray);
var IconMoreOptions = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {})
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (IconMoreOptions);


/***/ }),

/***/ 61645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ InputNumberContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69428);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);
/* eslint-disable react/jsx-props-no-spreading */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  justify-content: space-between;\n  width: 160px;\n  @media ",
        " {\n    margin: 0 15px;\n  }\n\n  .ant-input-number-focused,\n  .ant-input-number:hover,\n  .ant-input-number {\n    border: none !important;\n    box-shadow: none !important;\n  }\n  .ant-input-number-handler-wrap {\n    opacity: 1;\n    height: 100%;\n    background: #fff;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border: none;\n  }\n  .ant-input-number-handler {\n    background: #f5f6f7;\n    height: 30px;\n    line-height: 30px;\n    display: inline-block;\n    width: 30px;\n  }\n\n  .ant-input-number-handler-up {\n    position: absolute;\n    left: 128px;\n    border-left: 1px solid ",
        ';\n    cursor: pointer;\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJElEQVQI12P4//8/AwxnZ2f/R+YzMeABeCUZs7Oz/+OUpY2dAKdAKqbFFo6PAAAAAElFTkSuQmCC");\n    }\n  }\n\n  .ant-input-number-handler-down {\n    border: none;\n    border-right: 1px solid ',
        ';\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAH0lEQVQI12P8//8/Ay7AxIAH4JVkzM7OxmkuI23sBABa8QhG3y64OwAAAABJRU5ErkJggg==");\n    }\n  }\n  .ant-input-number-input {\n    text-align: center;\n  }\n\n  .ant-input-number-handler-up:hover,\n  .ant-input-number-handler-down,\n  .ant-input-number-handler-down:hover,\n  .ant-input-number-handler-up {\n    height: 30px !important;\n  }\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var InputNumber = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-47fea7ce-0"
})(_templateObject());
var InputNumberContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-47fea7ce-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);

/* harmony default export */ __webpack_exports__["Z"] = (InputNumber);


/***/ }),

/***/ 16368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    padding: unset;\n    border: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 0;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    height: 90%;\n    overflow-y: scroll;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  ",
        "\n\n  .ant-modal-content {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-697a6696-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}, function(param) {
    var radius = param.radius;
    return radius;
}));


/***/ }),

/***/ 70187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R_": function() { return /* binding */ PopoverContentWrapper; },
/* harmony export */   "xK": function() { return /* binding */ PopoverTitleWrapper; },
/* harmony export */   "yk": function() { return /* binding */ PopoverContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10808);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  max-height: 400px;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid ",
        ";\n  height: 40px;\n  padding: 0 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: 360px;\n  overflow-y: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var PopoverContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        padding: props.padding || 0
    };
}).withConfig({
    componentId: "sc-b405b759-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var padding = param.padding;
    return padding;
});
var PopoverTitleWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b405b759-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
var PopoverContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b405b759-2"
})(_templateObject2());

/* harmony default export */ __webpack_exports__["ZP"] = (antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);


/***/ }),

/***/ 12484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      border-radius: 0px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 2px 5px;\n      font-size: 11px;\n      line-height: 1;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 1px 5px;\n      font-size: 12px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 6px;\n      font-size: 12.5px;\n      line-height: 20px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 8px;\n      font-size: 14px;\n      line-height: 25px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  margin: ",
        ';\n  font-family: "ProximaNovaRg";\n  border-radius: 2px;\n  display: inline-block;\n  text-align: center;\n'
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  background-color: ",
        ";\n  text-align: center;\n  height: 30px;\n  padding: 0 10px;\n  border-left: 5px solid;\n  border-left-color: ",
        ";\n  animation-duration: 0.6s;\n  animation-fill-mode: both;\n  animation-timing-function: ease-out;\n  font-weight: bolder;\n  font-size: 18px;\n  line-height: 30px;\n  color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var tagProps = {
    theme: {
        "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary),
        veryLightGrey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].veryLightGrey */ .Z.veryLightGrey, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis),
        grey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        dark: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].nightRider */ .Z.nightRider, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        default: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro)
    },
    size: {
        xs: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5()),
        s: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6()),
        m: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject7()),
        l: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8())
    }
};
var tagColorByType = {
    up: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    down: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    neutral: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].midgray */ .Z.midgray
};
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        size: props.size || "m",
        type: props.type || "default",
        margin: props.margin || 0
    };
}).withConfig({
    componentId: "sc-74ce45aa-0"
})(_templateObject9(), function(param) {
    var type = param.type;
    return tagProps.theme[type];
}, function(param) {
    var size = param.size;
    return tagProps.size[size];
}, function(param) {
    var margin = param.margin;
    return margin;
});
var SymbolTag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        type: props.type || "neutral"
    };
}).withConfig({
    componentId: "sc-74ce45aa-1"
})(_templateObject10(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis, function(param) {
    var type = param.type;
    return tagColorByType[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
/* harmony default export */ __webpack_exports__["Z"] = ({
    Tag: Tag,
    SymbolTag: SymbolTag
});


/***/ }),

/***/ 39211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56266);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-71cb950b-0"
})(_templateObject()));


/***/ }),

/***/ 84607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 *
 * @param {number} percentNum - accept value 0 until 100
 * eg:
 * import hexOpacity from "./hexOpacity";
 *
 * ...
 * ...
 *  color: ${color.primary + hexOpacity(80)}
 * ...
 *
 */ var percentToHex = function() {
    var percentNum = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return Math.round(percentNum / 100 * 255).toString(16).padStart(2, "0");
};
/* harmony default export */ __webpack_exports__["Z"] = (percentToHex);


/***/ }),

/***/ 70524:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var RUNNING_TRADE = {
    SEARCH_INPUT: "running-trade-search-input",
    SEARCH_INPUT_CLEAR_BUTTON: "running-trade-search-input-clear-button"
};
var CALENDAR = {
    HEADER_MORE_BUTTON: "calendar-header-more-button",
    ROW_SYMBOL: "calendar-row-symbol"
};
var PROFILE = {
    HEADER_MORE_BUTTON: "profile-header-more-button",
    HEADER_BLOCK_BUTTON: "profile-header-block-button"
};
var CHATROOM = {
    GROUP_MEMBER: "chatroom-group-member",
    SEND_MESSAGE_BUTTON: "chatroom-send-message-button",
    CONFIRM_DELETE_MESSAGE_BUTTON: "chatroom-confirm-delete-message-button",
    CAPSULE_USER_NEW_GROUP: "chatroom-capsule-user-new-group",
    CAPSULE_USER_NEW_GROUP_CLOSE: "chatroom-capsule-user-new-group-close",
    SUGGESTED_USER: "chatroom-suggested-user"
};
var COMPANY = {
    NAVBAR_MORE_MENU: "company-navbar-more-menu",
    WIDGET_CATALOG: "company-widget-catalog",
    WIDGET_CATALOG_ITEM: "company-widget-catalog-item",
    WIDGET_INVESTMENT_MORE_BUTTON: "company-widget-investment-more-button"
};
var NOTIFICATION = {
    TITLE_TEXT: "notification-title-text"
};
var VALUATION = {
    HEADER_TITLE: "valuation-header-title",
    HEADER_MORE_BUTTON: "valuation-header-more-button"
};
var NAVIGATION = {
    MORE_MENU_BUTTON: "navigation-more-menu-button"
};
var GLOSSARY = {
    SEARCH_SUGGESTION: "glossary-search-suggestion"
};
var SHARE_POST = {
    CHECKBOX: "share-post-checkbox",
    SEND_BUTTON: "share-post-send-button"
};
var STREAM_POST = {
    CONFIRM_DELETE_BUTTON: "stream-post-confirm-delete-button",
    CONFIRM_CANCEL_BUTTON: "stream-post-confirm-cancel-button"
};
var EARNINGS = {
    SEARCH_SYMBOL_INPUT: "earnings-search-symbol-input",
    SEARCH_SYMBOL_BUTTON: "earnings-search-symbol-button",
    TABLE_ROW_SYMBOL: "earnings-table-row-symbol"
};
var FINANCIALS = {
    TABLE_TITLE_TEXT: "financials-table-title-text",
    TABLE_QUARTER_TEXT: "financials-table-quarter-text",
    TABLE_INCOME_TEXT: "financials-table-income-text"
};
var SCREENER = {
    DELETE_RULES_BUTTON: "screener-delete-rules-button",
    CLOSE_POPUP_BUTTON: "screener-close-popup-button",
    STOCK_SEARCH_INPUT: "screener-stock-search-input"
};
var LANDING = {
    REGISTER_BUTTON: "landing-register-button",
    LOGIN_BUTTON: "landing-login-button"
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    RUNNING_TRADE: RUNNING_TRADE,
    CALENDAR: CALENDAR,
    PROFILE: PROFILE,
    CHATROOM: CHATROOM,
    COMPANY: COMPANY,
    NOTIFICATION: NOTIFICATION,
    VALUATION: VALUATION,
    NAVIGATION: NAVIGATION,
    GLOSSARY: GLOSSARY,
    SHARE_POST: SHARE_POST,
    STREAM_POST: STREAM_POST,
    EARNINGS: EARNINGS,
    FINANCIALS: FINANCIALS,
    SCREENER: SCREENER,
    LANDING: LANDING
});


/***/ }),

/***/ 42361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ sourceMapperEventsPage; },
/* harmony export */   "y": function() { return /* binding */ sourceMapperLiveStream; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var sourceMapperLiveStream = {
    deeplink: "Deeplink",
    banner: "Banner",
    stream: "Stream",
    livestream: "Live Stream",
    research: "Research Tab"
};
var sourceMapperEventsPage = {
    deeplink: "Deeplink",
    research: "Research Tab (Icon)"
};



/***/ }),

/***/ 18382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ event_livestream; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/lib/entities/livestream.ts + 1 modules
var livestream = __webpack_require__(61942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/global/SEO/index.tsx
var SEO = __webpack_require__(26350);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./src/global/LiveStreamWidget/constants.ts
var constants = __webpack_require__(37489);
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/index.esm.js
var index_esm = __webpack_require__(5406);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Input.js
var Input = __webpack_require__(54325);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/features/event/livestream/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  left: 0px;\n  right: 0px;\n  position: absolute;\n  margin-right: 37px;\n\n  background: ",
        ";\n  height: 100%;\n  overflow: scroll;\n  margin: auto;\n\n  @media ",
        " {\n    position: relative;\n    padding: 0 20px;\n    overflow: unset;\n  }\n\n  @media ",
        " {\n    padding: 0 40px;\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  overflow-y: scroll;\n  padding-bottom: 0;\n  gap: 40px;\n  display: flex;\n  justify-content: center;\n  max-width: 100%;\n  min-width: auto;\n\n  // Hide scroll\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n  scrollbar-width: none; /* Firefox */\n\n  ::-webkit-scrollbar {\n    display: none;\n  }\n\n  @media ",
        " {\n    max-height: calc(100vh - 100px);\n    margin: auto;\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 760px;\n  height: 100%;\n  margin: 0;\n  flex-direction: column-reverse;\n  display: flex;\n  gap: 30px;\n\n  & > #livestream-widget-host-detail {\n    display: none;\n  }\n\n  @media ",
        " {\n    display: flex;\n    max-width: 760px;\n    flex-direction: column;\n    padding: 60px 0;\n    width: 100%;\n    height: 100%;\n\n    & > #livestream-widget-host-detail {\n      display: flex;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: 16px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n\n  @media ",
        " {\n    max-width: 650px;\n  }\n\n  @media ",
        " {\n    margin-bottom: unset;\n    max-width: unset;\n    flex-direction: column-reverse;\n    align-items: flex-start;\n    gap: 12px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  width: auto;\n  padding: 2.5px 8px;\n  border-radius: 10px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: auto;\n  margin: 0 20px;\n  gap: 20px;\n\n  & > #livestream-widget-host-detail {\n    margin-top: 20px;\n  }\n\n  @media ",
        " {\n    width: 100%;\n    max-width: 650px;\n  }\n\n  @media ",
        " {\n    width: 264px;\n    margin: 0px;\n\n    display: flex;\n    flex-direction: column;\n    padding-top: 60px;\n    position: sticky;\n    top: 0;\n\n    & > #livestream-widget-host-detail {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px;\n  border-radius: 6px;\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 32px;\n  height: 32px;\n  border-radius: 100%;\n  border: 0.5px solid ",
        ";\n\n  img {\n    width: 30px;\n    height: 30px;\n    border-radius: 100%;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 12px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 0.5px solid ",
        ";\n  border-radius: 6px;\n  padding: 16px;\n  margin-top: 20px;\n\n  @media ",
        " {\n    margin-top: unset;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 100%;\n  width: 32px;\n  height: 32px;\n  background: #e6fcef;\n  margin-right: 12px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n  width: 100%;\n  margin: 20px 0;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: min-content;\n  overflow: visible;\n  background: transparent;\n  cursor: pointer;\n\n  :hover {\n    background: transparent;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  opacity: 0.4;\n  display: flex;\n  align-items: center;\n  :hover {\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-content {\n    border-radius: 3px;\n    min-height: ",
        ";\n    display: flex;\n    flex-direction: column;\n  }\n  .ant-modal-header {\n    border-color: ",
        ";\n    border-radius: 3px 3px 0 0;\n    height: 66px;\n    padding: 0 20px !important;\n\n    .ant-modal-title {\n      padding: 20px 0;\n    }\n  }\n  .ant-modal-body {\n    padding: 10px 20px 20px 20px;\n    border-radius: 0 0 3px 3px;\n    display: flex;\n    flex-direction: column;\n    -webkit-box-flex: 1;\n    flex: 1 1 auto;\n\n    div {\n      display: flex;\n      flex-direction: column;\n      -webkit-box-flex: 1;\n      flex: 1 1 auto;\n    }\n  }\n  .ant-modal-footer {\n    padding: 0 !important;\n    text-align: left;\n    display: flex;\n  }\n  .ant-modal-close {\n    top: 20px;\n    right: 20px;\n\n    .ant-modal-close-x {\n      width: 25px;\n      height: 25px;\n      line-height: 25px;\n      font-size: 18px;\n    }\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 300px;\n  width: 100%;\n  margin: 10px auto;\n  position: relative;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        " !important;\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  position: absolute;\n  margin-top: 6px;\n  z-index: 1;\n  transition: 0.3s ease all;\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  padding-left: 0px;\n  padding-right: 0px;\n  border-bottom: 0.5px solid;\n  border-color: ",
        " !important;\n\n  &:not(:empty) {\n    border-color: ",
        " !important;\n  }\n\n  &:focus {\n    border-color: ",
        " !important;\n  }\n\n  &:not(:empty) ~ ",
        " {\n    font-size: 12px;\n    margin-top: -20px;\n  }\n\n  &:not(:empty) ~ ",
        '[color="',
        '"] {\n    color: ',
        " !important;\n  }\n\n  &:focus ~ ",
        '[color="',
        '"] {\n    font-size: 12px;\n    margin-top: -20px;\n    color: ',
        " !important;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  -webkit-box-flex: 1;\n  flex: 1 1 auto;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: var(--bold-font);\n  :disabled {\n    background: #7dd2b2;\n    color: ",
        ";\n    border: none;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  border: 1px solid ",
        ";\n  border-radius: 6px;\n  width: 100%;\n\n  @media ",
        " {\n    width: 856px !important;\n    margin-right: 48px;\n    display: content;\n\n    & > :nth-child(2) {\n      height: 100%;\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  margin-bottom: 40px;\n  border: 1px solid ",
        ";\n  border-radius: 6px;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  .ant-skeleton-button {\n    width: 100%;\n    height: 428px;\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 5px;\n  .ant-skeleton-button {\n    width: 200px;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-skeleton-title {\n    margin: 0px !important;\n    height: 20px;\n    width: 100% !important;\n  }\n  .ant-skeleton-paragraph {\n    margin-top: 5px !important;\n    li {\n      height: 10px;\n      margin-top: 10px !important;\n    }\n    & > :first-child {\n      width: 30%;\n      height: 15px !important;\n    }\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: linear-gradient(90deg, #eee 8%, #f0f0f0 18%, #eee 33%);\n  border-radius: 6px;\n  position: relative;\n  padding-bottom: 56.25%;\n  height: 100%;\n  overflow: hidden;\n  max-height: 426px;\n\n  iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n\n  @media ",
        " {\n    iframe {\n      border-radius: 6px;\n    }\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 51.448%;\n  background: linear-gradient(90deg, #eee 8%, #f0f0f0 18%, #eee 33%);\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  max-height: 200px;\n\n  #livestream-banner-image-cover {\n    width: 100%;\n    height: 100%;\n  }\n\n  img {\n    width: 100%;\n    height: 100%;\n  }\n\n  @media ",
        " {\n    border: 1px solid #ededed;\n    border-radius: 6px;\n\n    #livestream-banner-image-cover {\n      left: 0;\n      top: 0;\n    }\n\n    img {\n      border-radius: 6px;\n    }\n  }\n\n  @media ",
        " {\n    max-height: 400px;\n  }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  box-sizing: border-box;\n  border-radius: 4px;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 19px;\n  text-align: center;\n  color: ",
        ";\n  font-family: var(--font-bold);\n  border: 1px solid ",
        ";\n  padding: 12px 16px;\n  margin-top: 20px;\n  width: 100%;\n  cursor: pointer;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}









var TextArea = Input/* default.TextArea */.Z.TextArea;
var ContainerBackground = {
    EVENT_STATUS_UPCOMING: "#4f4be8",
    EVENT_STATUS_LIVE: "linear-gradient(255.44deg, #4F4BE8 -2.84%, #9042E1 158.53%)",
    EVENT_STATUS_ENDED: "linear-gradient(255.44deg, #4f4be8 -2.84%, #9042e1 158.53%)"
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a80cada5-0"
})(_templateObject(), color/* default.light */.Z.light, device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a80cada5-1"
})(_templateObject1(), device/* default.laptop */.Z.laptop);
var StreamBoxLeftWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a80cada5-2"
})(_templateObject2(), device/* default.laptop */.Z.laptop);
var PlayerHeaderContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-a80cada5-3"
})(_templateObject3(), function(param) {
    var status = param.status;
    return ContainerBackground[status];
}, device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var EventBadgeContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-a80cada5-4"
})(_templateObject4(), function(param) {
    var status = param.status;
    return status === "EVENT_STATUS_LIVE" ? color/* default.sunsetOrange */.Z.sunsetOrange : "rgba(0,0,0,.2)";
});
var VideoPlayerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a80cada5-5"
})(_templateObject5());
var BannerContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-a80cada5-6"
})(_templateObject6());
var StreamBoxRightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a80cada5-7"
})(_templateObject7(), device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var WidgetHostContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a80cada5-8"
})(_templateObject8(), color/* default.downgray */.Z.downgray);
var HostLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a80cada5-9"
})(_templateObject9(), color/* default.downgray */.Z.downgray);
var HostDetail = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    direction: "column"
}).withConfig({
    componentId: "sc-a80cada5-10"
})(_templateObject10());
var WidgetInfoActionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a80cada5-11"
})(_templateObject11(), color/* default.downgray */.Z.downgray, device/* default.laptop */.Z.laptop);
var IconContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-a80cada5-12"
})(_templateObject12());
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a80cada5-13"
})(_templateObject13(), color/* default.downgray */.Z.downgray);
var ButtonUnstyled = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a80cada5-14"
})(_templateObject14());
var LivePlayerButton = (0,styled_components_browser_esm/* default */.ZP)(ButtonUnstyled).withConfig({
    componentId: "sc-a80cada5-15"
})(_templateObject15());
var styled_Modal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-a80cada5-16"
})(_templateObject16(), function(param) {
    var isResult = param.isResult;
    return isResult ? "295px" : "346px";
}, color/* default.gainsboro */.Z.gainsboro);
var InputGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a80cada5-17"
})(_templateObject17());
var Label = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    size: "14px",
    height: "19px"
}).withConfig({
    componentId: "sc-a80cada5-18"
})(_templateObject19(), function(param) {
    var textColor = param.color;
    return textColor && (0,styled_components_browser_esm/* css */.iv)(_templateObject18(), textColor);
});
var Textarea = (0,styled_components_browser_esm/* default */.ZP)(TextArea).attrs({
    autoSize: {
        minRows: 1,
        maxRows: 6
    }
}).withConfig({
    componentId: "sc-a80cada5-19"
})(_templateObject20(), function(param) {
    var matchMaxChar = param.matchMaxChar;
    return matchMaxChar ? color/* default.sunsetOrange */.Z.sunsetOrange : color/* default.midgray */.Z.midgray;
}, function(param) {
    var matchMaxChar = param.matchMaxChar;
    return matchMaxChar ? color/* default.sunsetOrange */.Z.sunsetOrange : color/* default.primary */.Z.primary;
}, function(param) {
    var matchMaxChar = param.matchMaxChar;
    return matchMaxChar ? color/* default.sunsetOrange */.Z.sunsetOrange : color/* default.primary */.Z.primary;
}, Label, Label, color/* default.midgray */.Z.midgray, color/* default.primary */.Z.primary, Label, color/* default.midgray */.Z.midgray, color/* default.primary */.Z.primary);
var ModalQuestionContent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    direction: "column",
    align: "space-between"
}).withConfig({
    componentId: "sc-a80cada5-20"
})(_templateObject21());
var ButtonSubmitQuestion = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    type: "primary",
    width: "100%",
    height: "42px",
    radius: "4px"
}).withConfig({
    componentId: "sc-a80cada5-21"
})(_templateObject22(), color/* default.light */.Z.light);
var ShimmerBoxLeft = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a80cada5-22"
})(_templateObject23(), color/* default.downgray */.Z.downgray, device/* default.laptop */.Z.laptop);
var ShimmerRightWidget = (0,styled_components_browser_esm/* default */.ZP)(StreamBoxRightWrapper).withConfig({
    componentId: "sc-a80cada5-23"
})(_templateObject24(), color/* default.downgray */.Z.downgray);
var ShimmerPlayer = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default.Button */.Z.Button).withConfig({
    componentId: "sc-a80cada5-24"
})(_templateObject25());
var ShimmerTitle = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default.Button */.Z.Button).attrs({
    size: "small",
    active: true
}).withConfig({
    componentId: "sc-a80cada5-25"
})(_templateObject26());
var ShimmerItem = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default */.Z).attrs({
    active: true
}).withConfig({
    componentId: "sc-a80cada5-26"
})(_templateObject27());
var YoutubeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a80cada5-27"
})(_templateObject28(), device/* default.tablet */.Z.tablet);
var PlayerBannerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a80cada5-28"
})(_templateObject29(), device/* default.laptop */.Z.laptop, device/* default.laptopL */.Z.laptopL);
var ButtonReload = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a80cada5-29"
})(_templateObject30(), color/* default.light */.Z.light, color/* default.primary */.Z.primary, color/* default.downgray */.Z.downgray);


// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
;// CONCATENATED MODULE: ./src/features/event/livestream/PlayerBanner.tsx



function PlayerBanner(param) {
    var image = param.image, isCanPlay = param.isCanPlay, onPlay = param.onPlay;
    if (isCanPlay) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PlayerBannerContainer, {
            id: "livestream-banner-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: image,
                    alt: "banner",
                    id: "livestream-banner-image-cover"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LivePlayerButton, {
                        onClick: onPlay,
                        id: "livestream-banner-play-button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "/icon/play-youtube.svg"
                        })
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayerBannerContainer, {
        id: "livestream-banner-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: image,
            alt: "banner",
            id: "livestream-banner-image-cover"
        })
    });
}
/* harmony default export */ var livestream_PlayerBanner = (PlayerBanner);

// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./node_modules/autolinker/dist/es2015/index.js + 26 modules
var es2015 = __webpack_require__(51841);
;// CONCATENATED MODULE: ./src/features/event/livestream/WidgetHostDetail.tsx









var MAX_DESCRIPTION_LENGTH = 286;
function WidgetHostDetail(param) {
    var name = param.name, description = param.description, logoUrl = param.logoUrl;
    var ref = (0,react.useState)(false), more = ref[0], showMore = ref[1];
    var showedDescription = (0,react.useMemo)(function() {
        if (description.length > MAX_DESCRIPTION_LENGTH && !more) {
            var croppedText = "";
            description.replace(/\s+/g, "  ").split(" ").every(function(word, index) {
                var temp = index === 0 ? word : [
                    croppedText,
                    word
                ].join(" ");
                if (temp.length > MAX_DESCRIPTION_LENGTH) {
                    return false;
                }
                croppedText = temp;
                return true;
            });
            var htmlString = es2015/* default.link */.ZP.link(croppedText, {
                stripPrefix: false
            });
            return (0,html_react_parser/* default */.ZP)(sanitize_html_default()("".concat(htmlString, "...")));
        }
        var htmlString1 = sanitize_html_default()(es2015/* default.link */.ZP.link(description.replace(/(\n|\r\n)/g, "<br />"), {
            stripPrefix: false
        }));
        var parsedText = (0,html_react_parser/* default */.ZP)(htmlString1);
        return parsedText;
    }, [
        more,
        description
    ]);
    var showReadMore = !more && description.length > MAX_DESCRIPTION_LENGTH;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidgetHostContainer, {
        id: "livestream-widget-host-detail",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HostLogo, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: logoUrl,
                    alt: "".concat(name, " Logo"),
                    id: "livestream-widget-host-logo"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HostDetail, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "13px",
                        height: "18px",
                        weight: "700",
                        family: "bold",
                        color: color/* default.highempahis */.Z.highempahis,
                        id: "livestream-widget-host-name",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        weight: "400",
                        size: "11px",
                        height: "15px",
                        color: color/* default.highgray */.Z.highgray,
                        children: "Host"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        // @ts-expect-error
                        mt: "12px",
                        weight: "400",
                        size: "13px",
                        height: "20px",
                        color: color/* default.highempahis */.Z.highempahis,
                        id: "livestream-widget-host-description",
                        children: [
                            showedDescription,
                            showReadMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: color/* default.primary */.Z.primary,
                                family: "bold",
                                onClick: function() {
                                    return showMore(true);
                                },
                                style: {
                                    cursor: "pointer",
                                    display: "inline-block"
                                },
                                id: "livestream-widget-host-description-readmore",
                                children: "Read more"
                            })
                        ]
                    }),
                    more && description.length > MAX_DESCRIPTION_LENGTH && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: color/* default.primary */.Z.primary,
                        family: "bold",
                        onClick: function() {
                            return showMore(false);
                        },
                        style: {
                            cursor: "pointer"
                        },
                        id: "livestream-widget-host-description-showless",
                        children: "Show Less"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var livestream_WidgetHostDetail = (WidgetHostDetail);

;// CONCATENATED MODULE: ./src/features/event/livestream/StreamBoxLeft.tsx







function StreamBoxLeft(param) {
    var event = param.event;
    var media = event.media, status = event.status, _host = event.host, description = _host.description, name = _host.name, logoUrl = _host.logo_url;
    var thumbnailUrl = media.thumbnail_url, thumbnailUpcoming = media.thumbnail_upcoming_url;
    var playerRef = (0,react.useRef)();
    var ref = (0,react.useState)(false), showBanner = ref[0], setShowBanner = ref[1];
    var youtubeOptions = {
        width: "100%",
        height: "360",
        playerVars: {
            mute: 0
        }
    };
    var onClickPlay = function() {
        var ref, ref1;
        setShowBanner(false);
        playerRef === null || playerRef === void 0 ? void 0 : (ref = playerRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.internalPlayer) === null || ref1 === void 0 ? void 0 : ref1.playVideo();
    };
    (0,react.useEffect)(function() {
        if (thumbnailUrl !== "" && status !== constants/* EVENT_STATUS.LIVE */.d.LIVE) {
            setShowBanner(true);
        } else if (thumbnailUpcoming !== "" && status === constants/* EVENT_STATUS.UPCOMING */.d.UPCOMING) {
            setShowBanner(true);
        }
    }, []);
    var isLive = status === constants/* EVENT_STATUS.LIVE */.d.LIVE;
    var isEnded = status === constants/* EVENT_STATUS.ENDED */.d.ENDED;
    var isCanPlay = isLive || isEnded;
    var thumbUrl = isEnded && thumbnailUrl !== "" ? thumbnailUrl : thumbnailUpcoming;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StreamBoxLeftWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayerContainer, {
                style: {
                    display: showBanner ? "none" : "block"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubeContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.Z, {
                        videoId: media.id,
                        opts: youtubeOptions,
                        ref: playerRef,
                        id: "livestream-youtube-player"
                    })
                })
            }),
            showBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(livestream_PlayerBanner, {
                image: thumbUrl,
                isCanPlay: isCanPlay,
                onPlay: onClickPlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(livestream_WidgetHostDetail, {
                description: description,
                name: name,
                logoUrl: logoUrl
            })
        ]
    });
}
/* harmony default export */ var livestream_StreamBoxLeft = (StreamBoxLeft);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/global/ModalShare/index.tsx + 9 modules
var ModalShare = __webpack_require__(41232);
// EXTERNAL MODULE: ./src/lib/entities/chat/slice.ts
var slice = __webpack_require__(10707);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./node_modules/ics/index.js
var ics = __webpack_require__(39136);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/features/event/livestream/utils.ts
/* eslint-disable import/prefer-default-export */ 

var downloadReminder = function(eventStart, eventEnd, eventTitle) {
    var momentDateStart = moment_default()(eventStart);
    var momentDateEnd = moment_default()(eventEnd);
    var startEvent = [
        momentDateStart.year(),
        momentDateStart.month() + 1,
        momentDateStart.date(),
        momentDateStart.hour(),
        momentDateStart.minute(), 
    ];
    var endEvent = [
        momentDateEnd.year(),
        momentDateEnd.month() + 1,
        momentDateEnd.date(),
        momentDateEnd.hour(),
        momentDateEnd.minute(), 
    ];
    var reminderTime = [
        {
            action: "display",
            trigger: {
                hours: 0,
                minutes: 3,
                before: true
            }
        }
    ];
    ics.createEvent({
        start: startEvent,
        end: endEvent,
        title: eventTitle,
        status: "CONFIRMED",
        alarms: reminderTime,
        description: "Reminder to Stockbit Event"
    }, function(error, value) {
        if (error) {
            ;
            return;
        }
        // write .ics file
        var blob = new Blob([
            value
        ], {
            type: "text/calendar;charset=utf-8"
        });
        var url = URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.download = "stockbit_event.ics";
        link.href = url;
        link.click();
    });
};


;// CONCATENATED MODULE: ./src/features/event/livestream/Modal/QuestionResulStatus.tsx




var statusType = {
    success: {
        ilustration: "/illustration/livestream-question-success.svg",
        text: "Your question has been sent."
    },
    error: {
        ilustration: "/illustration/livestream-question-limit.svg",
        text: "You have reached the limit of sending 3 questions."
    }
};
function QuestionResultStatus(param) {
    var status = param.status;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                width: "180",
                height: "135",
                src: statusType[status].ilustration,
                id: "livestream-modal-question-result-image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                // @ts-expect-error
                mt: "25px",
                size: "14px",
                height: "19px",
                id: "livestream-modal-question-result-status",
                children: statusType[status].text
            })
        ]
    });
}
/* harmony default export */ var QuestionResulStatus = (QuestionResultStatus);

// EXTERNAL MODULE: ./src/utils/clevertap.js
var clevertap = __webpack_require__(48028);
;// CONCATENATED MODULE: ./src/features/event/livestream/analytics/Question.ts

var EVENTS = {
    navigate: "Submit Question Viewed"
};
var ACTIONS = {
    openSubmitQuestion: "Live Stream Submit Question Selected",
    questioFilled: "Question Filled",
    questionSubmited: "Live Stream Question Submitted"
};
var LivestreamQuestionAnalytics = {
    Navigate: {
        View: function() {
            (0,clevertap/* clevertapEvent */.Lq)(EVENTS.navigate);
        }
    },
    Action: {
        openModal: function(params) {
            (0,clevertap/* clevertapEvent */.Lq)(ACTIONS.openSubmitQuestion, params);
        },
        questionFilled: function() {
            (0,clevertap/* clevertapEvent */.Lq)(ACTIONS.questioFilled);
        },
        questionSubmited: function(params) {
            (0,clevertap/* clevertapEvent */.Lq)(ACTIONS.questionSubmited, params);
        }
    }
};
/* harmony default export */ var Question = (LivestreamQuestionAnalytics);

;// CONCATENATED MODULE: ./src/features/event/livestream/Modal/ModalQuestion.tsx












function ModalQuestion(param) {
    var visible = param.visible, onCancel = param.onCancel, onSubmit = param.onSubmit;
    var ref = (0,es/* useSelector */.v9)(livestream/* selectors */.wl), _writeQuestions = ref.writeQuestions, isLoading = _writeQuestions.isLoading, error = _writeQuestions.error;
    var ref1 = (0,react.useState)(false), isSubmit = ref1[0], setIsSubmit = ref1[1];
    var ref2 = (0,react.useState)(""), question = ref2[0], setQuestion = ref2[1];
    var ref3 = (0,react.useState)(false), isResult = ref3[0], setIsResult = ref3[1];
    var matchMaxChar = question.length > 280;
    var isDisabled = matchMaxChar || question.length === 0;
    var onSubmitQuestion = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var submit;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsSubmit(true);
                        _ctx.next = 3;
                        return onSubmit(question);
                    case 3:
                        submit = _ctx.sent;
                        setIsResult(true);
                        if (submit) {
                            setTimeout(function() {
                                onCancel();
                                setQuestion("");
                                setIsSubmit(false);
                            }, 3000);
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmitQuestion() {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeQuestion = function(e) {
        setQuestion(e.target.value);
        Question.Action.questionFilled();
    };
    (0,react.useEffect)(function() {
        setIsResult(false);
    }, [
        visible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Modal, {
        visible: visible,
        onCancel: onCancel,
        centered: true,
        footer: null,
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            size: "18px",
            family: "bold",
            align: "center",
            children: "Questions"
        }),
        width: 430,
        isResult: isResult,
        destroyOnClose: true,
        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/close.svg",
            width: "12",
            height: "12"
        }),
        wrapClassName: "livestream-modal-question",
        children: isSubmit && !isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionResulStatus, {
            status: !error ? "success" : "error"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalQuestionContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputGroup, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea, {
                            // @ts-expect-error
                            width: "360px",
                            onChange: onChangeQuestion,
                            value: question,
                            matchMaxChar: matchMaxChar,
                            id: "livestream-modal-question-input"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                            color: matchMaxChar ? color/* default.sunsetOrange */.Z.sunsetOrange : color/* default.midgray */.Z.midgray,
                            // @ts-expect-error
                            status: "error",
                            children: "Question"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            align: "right",
                            size: "12px",
                            height: "16px",
                            // @ts-expect-error
                            mt: "4px",
                            color: matchMaxChar ? color/* default.sunsetOrange */.Z.sunsetOrange : color/* default.midgray */.Z.midgray,
                            children: [
                                question.length,
                                " / 280"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSubmitQuestion, {
                    disabled: isDisabled,
                    onClick: onSubmitQuestion,
                    loading: isLoading,
                    id: "livestream-modal-question-submit",
                    children: "Submit"
                })
            ]
        })
    });
}
/* harmony default export */ var Modal_ModalQuestion = (ModalQuestion);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
;// CONCATENATED MODULE: ./src/features/event/livestream/ItemInfoAction.tsx







function ItemInfoAction(param) {
    var onClick = param.onClick, title = param.title, description = param.description, iconName = param.iconName, id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                id: "".concat(id, "-container"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonUnstyled, {
                    onClick: onClick,
                    id: "".concat(id, "-button"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        align: "center",
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: "/icon/".concat(iconName, ".svg")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        direction: "column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                family: "bold",
                                                size: "13px",
                                                height: "18px",
                                                weight: "700",
                                                color: color/* default.highempahis */.Z.highempahis,
                                                id: "".concat(id, "-title"),
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                size: "11px",
                                                height: "15px",
                                                weight: "400",
                                                color: color/* default.highgray */.Z.highgray,
                                                id: "".concat(id, "-description"),
                                                children: description
                                            })
                                        ]
                                    })
                                ]
                            }),
                            onClick && /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                                id: "".concat(id, "-next-icon"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                    className: "icon-toolbar_next",
                                    size: "16px",
                                    color: color/* default.highgray */.Z.highgray,
                                    hoverColor: color/* default.highgray */.Z.highgray
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var livestream_ItemInfoAction = (ItemInfoAction);

;// CONCATENATED MODULE: ./src/features/event/livestream/analytics/Livestream.ts

var Livestream_EVENTS = {
    navigate: "Live Stream Event Detail Viewed"
};
var Livestream_ACTIONS = {
    shareButtonSelected: "Live Stream Share Button Selected",
    setReminder: "Live Stream Set reminder Selected"
};
var LivestreamAnalytics = {
    Navigate: {
        ViewPage: function(params) {
            (0,clevertap/* clevertapEvent */.Lq)(Livestream_EVENTS.navigate, params);
        }
    },
    Action: {
        shareButtonSelected: function(params) {
            (0,clevertap/* clevertapEvent */.Lq)(Livestream_ACTIONS.shareButtonSelected, params);
        },
        setReminder: function(params) {
            (0,clevertap/* clevertapEvent */.Lq)(Livestream_ACTIONS.setReminder, params);
        }
    }
};
/* harmony default export */ var Livestream = (LivestreamAnalytics);

;// CONCATENATED MODULE: ./src/features/event/livestream/WidgetInfoAction.tsx

























function WidgetInfoAction(param) {
    var event = param.event;
    var schedule = event.schedule, eventId = event.id, eventCode = event.code, eventTitle = event.title, showReminder = event.reminder_enabled, questionEnabled = event.question_enabled, status = event.status;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = [
        (0,format/* default */.Z)((0,parseISO/* default */.Z)(schedule.start), "HH:mm"),
        (0,format/* default */.Z)((0,parseISO/* default */.Z)(schedule.end), "HH:mm"), 
    ], startTime = ref[0], endTime = ref[1];
    var ref1 = (0,react.useState)(false), showShareModal = ref1[0], setShowShareModal = ref1[1];
    var ref2 = (0,react.useState)(false), showQnaModal = ref2[0], setShowQnaModal = ref2[1];
    var ref3 = (0,react.useState)(""), sharedUrl = ref3[0], setSharedUrl = ref3[1];
    var defaultClevertapParams = {
        event_date: (0,format/* default */.Z)((0,parseISO/* default */.Z)(schedule.start), "dd MMMM yyyy"),
        event_status: status === constants/* EVENT_STATUS.LIVE */.d.LIVE ? "Live" : "Upcoming",
        live_stream_name: eventTitle
    };
    var onSubmitQuestion = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(question) {
            var submitQuestion, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(livestream/* effects.writeQuestion */.Sz.writeQuestion({
                            id: eventId,
                            question: question
                        }));
                    case 2:
                        submitQuestion = _ctx.sent;
                        data = submitQuestion.payload.data;
                        if (!data) {
                            _ctx.next = 7;
                            break;
                        }
                        Question.Action.questionSubmited(defaultClevertapParams);
                        return _ctx.abrupt("return", data);
                    case 7:
                        return _ctx.abrupt("return", false);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmitQuestion(question) {
            return _ref.apply(this, arguments);
        };
    }();
    var onSetReminder = function() {
        downloadReminder(schedule.start, schedule.end, eventTitle);
        var cleverTapParams = (0,_object_spread/* default */.Z)({
            status: "on"
        }, defaultClevertapParams);
        Livestream.Action.setReminder(cleverTapParams);
    };
    var handleClickShowShareModal = function() {
        setShowShareModal(true);
        Livestream.Action.shareButtonSelected(defaultClevertapParams);
    };
    var handleClickQnaButton = function() {
        Question.Action.openModal(defaultClevertapParams);
        setShowQnaModal(true);
        Question.Navigate.View();
    };
    var handleCopyLink = function() {
        (0,general/* copyTextToClipboard */.TE)(sharedUrl, function() {
            return (0,AlertErrorMessage/* default */.Z)("Link Copied! Go ahead and share it!", "plain-green");
        });
    };
    var shareToChat = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(chatData) {
            var send, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(slice/* effects.shareEventToChat */.Sz.shareEventToChat((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatData), {
                            attachment_url: ""
                        })));
                    case 2:
                        send = _ctx.sent;
                        error = send.payload.error;
                        if (!error) {
                            setShowShareModal(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function shareToChat(chatData) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var path = !app/* PROJECT_FOLDER */.sP || app/* PROJECT_FOLDER */.sP === "/" ? "/" : "/".concat(app/* PROJECT_FOLDER */.sP, "/");
        setSharedUrl("".concat(window.location.origin).concat(path, "stream/event/").concat(eventCode, "/").concat(eventId));
    }, []);
    var sharedMessage = "Tonton live stream ".concat(eventTitle, " di Stockbit.\n").concat(sharedUrl);
    var showQna = status !== constants/* EVENT_STATUS.ENDED */.d.ENDED && questionEnabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidgetInfoActionContainer, {
        id: "livestream-widget-info",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "/icon/calendar-green.svg"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                family: "bold",
                                size: "13px",
                                height: "18px",
                                weight: "700",
                                color: color/* default.highempahis */.Z.highempahis,
                                id: "livestream-widget-info-date",
                                children: (0,format/* default */.Z)((0,parseISO/* default */.Z)(schedule.start), "dd MMMM yyyy")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                size: "11px",
                                height: "15px",
                                weight: "400",
                                color: color/* default.highgray */.Z.highgray,
                                id: "livestream-widget-info-time",
                                children: [
                                    startTime,
                                    " - ",
                                    endTime,
                                    " WIB"
                                ]
                            })
                        ]
                    })
                ]
            }),
            showReminder && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(livestream_ItemInfoAction, {
                    onClick: onSetReminder,
                    title: "Set Reminder",
                    description: "Get notification when the event is live",
                    iconName: "notification-green",
                    id: "livestream-widget-info-reminder"
                })
            }),
            showQna && /*#__PURE__*/ (0,jsx_runtime.jsx)(livestream_ItemInfoAction, {
                onClick: handleClickQnaButton,
                title: "Submit Questions",
                description: "You can ask up to 3 questions",
                iconName: "chat-green",
                id: "livestream-widget-info-qna"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(livestream_ItemInfoAction, {
                onClick: handleClickShowShareModal,
                title: "Share This Event",
                description: null,
                iconName: "share-green",
                id: "livestream-widget-info-share"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare["default"], {
                visible: showShareModal,
                onCancel: function() {
                    return setShowShareModal(false);
                },
                title: "Share",
                sendChat: function(chatData) {
                    return shareToChat(chatData);
                },
                hasSocialMedia: true,
                hasShareInput: true,
                hasRepostButton: true,
                hasCopyButton: true,
                urlToShare: sharedUrl,
                defaultSharedMessage: sharedMessage,
                onCopy: handleCopyLink
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_ModalQuestion, {
                visible: showQnaModal,
                onCancel: function() {
                    return setShowQnaModal(false);
                },
                onSubmit: onSubmitQuestion
            })
        ]
    });
}
/* harmony default export */ var livestream_WidgetInfoAction = (WidgetInfoAction);

;// CONCATENATED MODULE: ./src/features/event/livestream/PlayerHeader.tsx





var LABEL = {
    EVENT_STATUS_UPCOMING: "Upcoming",
    EVENT_STATUS_LIVE: "LIVE",
    EVENT_STATUS_ENDED: "Live Ended"
};
function PlayerHeader(param) {
    var title = param.title, status = param.status, isLive = param.isLive;
    return(// @ts-expect-error
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PlayerHeaderContainer, {
        status: status,
        id: "livestream-player-header",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: color/* default.light */.Z.light,
                size: "16px",
                height: "22px",
                family: "bold",
                weight: "700",
                id: "livestream-player-header-title",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventBadgeContainer, {
                status: status,
                id: "livestream-player-header-badge",
                children: [
                    isLive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/icon/dot-light.svg",
                        id: "livestream-player-header-badge-live"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: color/* default.light */.Z.light,
                        size: "11px",
                        // @ts-expect-error
                        ml: "4px",
                        width: "max-content",
                        family: "bold",
                        id: "livestream-player-header-badge-status",
                        children: LABEL[status] ? LABEL[status] : ""
                    })
                ]
            })
        ]
    }));
}
/* harmony default export */ var livestream_PlayerHeader = (PlayerHeader);

;// CONCATENATED MODULE: ./src/features/event/livestream/StreamBoxRight.tsx






function StreamBoxRight(param) {
    var event = param.event;
    var _host = event.host, description = _host.description, name = _host.name, logoUrl = _host.logo_url, status = event.status, title = event.title;
    var isLive = status === constants/* EVENT_STATUS.LIVE */.d.LIVE;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StreamBoxRightWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(livestream_PlayerHeader, {
                isLive: isLive,
                title: title,
                status: status
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(livestream_WidgetInfoAction, {
                event: event
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(livestream_WidgetHostDetail, {
                description: description,
                name: name,
                logoUrl: logoUrl
            })
        ]
    });
}
/* harmony default export */ var livestream_StreamBoxRight = (StreamBoxRight);

;// CONCATENATED MODULE: ./src/features/event/livestream/Shimmer.tsx



function Shimmer() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        id: "livestream-shimmer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerBoxLeft, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerPlayer, {
                                active: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerBoxLeft, {
                            style: {
                                marginTop: "20px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem, {
                                avatar: true,
                                paragraph: {
                                    rows: 4
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShimmerRightWidget, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerTitle, {
                                    size: "small"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Button */.Z.Button, {
                                    size: "small",
                                    active: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShimmerRightWidget, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem, {
                                    avatar: true,
                                    paragraph: {
                                        rows: 1
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem, {
                                    avatar: true,
                                    paragraph: {
                                        rows: 1
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem, {
                                    avatar: true,
                                    paragraph: {
                                        rows: 1
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var livestream_Shimmer = (Shimmer);

;// CONCATENATED MODULE: ./src/features/event/livestream/Modal/ModalLiveError.tsx





function ModalLiveError(param) {
    var visible = param.visible, onCancel = param.onCancel, onReload = param.onReload;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Modal, {
        visible: visible,
        onCancel: onCancel,
        centered: true,
        footer: null,
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            size: "18px",
            family: "bold",
            align: "center",
            children: "Unable to Load"
        }),
        width: 420,
        isResult: true,
        destroyOnClose: true,
        wrapClassName: "livestream-modal-live-error",
        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/close.svg",
            width: "12",
            height: "12"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            align: "center",
            padding: "0 20px 10px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    width: "180",
                    height: "135",
                    src: "/illustration/livestream-error-event.svg",
                    alt: "Livestream Error"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    // @ts-expect-error
                    mt: "25px",
                    size: "14px",
                    height: "19px",
                    align: "center",
                    children: "Don't worry, we're trying to fix it. You can try again later."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonReload, {
                    onClick: onReload,
                    children: "Try Again"
                })
            ]
        })
    });
}
/* harmony default export */ var Modal_ModalLiveError = (ModalLiveError);

// EXTERNAL MODULE: ./src/features/event/constants.ts
var event_constants = __webpack_require__(42361);
;// CONCATENATED MODULE: ./src/features/event/livestream/index.tsx

















function LiveStream(param) {
    var eventId = param.eventId, isError = param.isError;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref = (0,es/* useSelector */.v9)(livestream/* selectors */.wl), _event = ref.event, eventData = _event.data, isLoading = _event.isLoading;
    var ref1 = (0,react.useState)(false), showErrorModal = ref1[0], setShowErrorModal = ref1[1];
    var sendAnalytic = function() {
        var schedule = eventData.schedule;
        var source = router.query.source;
        var clevertapParams = {
            event_date: (0,format/* default */.Z)((0,parseISO/* default */.Z)(schedule === null || schedule === void 0 ? void 0 : schedule.start), "dd MMMM yyyy"),
            event_status: (eventData === null || eventData === void 0 ? void 0 : eventData.status) === constants/* EVENT_STATUS.LIVE */.d.LIVE ? "Live" : "Upcoming",
            reminder_status: (eventData === null || eventData === void 0 ? void 0 : eventData.reminder_enabled) ? "on" : "off",
            live_stream_name: eventData === null || eventData === void 0 ? void 0 : eventData.title,
            // @ts-ignore
            source: source ? event_constants/* sourceMapperLiveStream */.y[source] : event_constants/* sourceMapperLiveStream.stream */.y.stream
        };
        Livestream.Navigate.ViewPage(clevertapParams);
    };
    var getEventDetail = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var getEvent, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(livestream/* effects.getEvent */.Sz.getEvent(eventId));
                    case 2:
                        getEvent = _ctx.sent;
                        data = getEvent.payload.data;
                        if (!data) {
                            setShowErrorModal(true);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getEventDetail() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        document.getElementById("main-container").setAttribute("style", "\n        height: calc(100vh - 100px);\n        max-width: unset;\n        overflow-y: hidden;\n      ");
        document.getElementsByTagName("body")[0].setAttribute("style", "\n        height: unset;\n      ");
        document.getElementById("main-container").getElementsByTagName("div")[0].setAttribute("style", "display: none");
        getEventDetail();
    }, []);
    (0,react.useEffect)(function() {
        if (eventData) {
            sendAnalytic();
        }
    }, [
        eventData
    ]);
    if (isLoading || !eventData || isError) {
        var closeModalEnded = function() {
            setShowErrorModal(false);
            router.push("/stream");
        };
        var handleReload = function() {
            router.reload();
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(livestream_Shimmer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_ModalLiveError, {
                    visible: showErrorModal,
                    onCancel: closeModalEnded,
                    onReload: handleReload
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(livestream_StreamBoxLeft, {
                        event: eventData
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(livestream_StreamBoxRight, {
                        event: eventData
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var event_livestream = (LiveStream);


/***/ }),

/***/ 70175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);

var useAuthModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        visible: false,
        tradingModalConfig: null,
        showModal: function() {
            var tradingModalConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            set({
                tradingModalConfig: tradingModalConfig,
                visible: true
            });
        },
        closeModal: function() {
            set({
                tradingModalConfig: null,
                visible: false
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useAuthModalStore);


/***/ }),

/***/ 63576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "en": function() { return /* binding */ PAGE_SOURCE_INDEX; },
/* harmony export */   "j4": function() { return /* binding */ mainProfileEvents; },
/* harmony export */   "nP": function() { return /* binding */ PAGE_SOURCE; }
/* harmony export */ });
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var PAGE_SOURCE;
(function(PAGE_SOURCE) {
    PAGE_SOURCE["streamPost"] = "Stream Post";
    PAGE_SOURCE["streamLikeList"] = "Stream Like List";
    PAGE_SOURCE["companyPage"] = "Company Page";
    PAGE_SOURCE["chat"] = "Chat";
    PAGE_SOURCE["search"] = "Search";
    PAGE_SOURCE["discoverPeople"] = "Discover People";
    PAGE_SOURCE["followers"] = "Followers";
    PAGE_SOURCE["following"] = "Following";
})(PAGE_SOURCE || (PAGE_SOURCE = {}));
var PAGE_SOURCE_INDEX = [
    "Stream Post",
    "Stream Like List",
    "Company Page",
    "Chat",
    "Search",
    "Discover People",
    "Followers",
    "Following",
    "My Profile",
    "Group Chat Bottom Sheet", 
];
var mainProfileEvents = {
    onViewProfile: function(pageSource) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Stream View Profile", {
            "Page Source": pageSource
        });
    },
    onUserProfileViewed: function(pageSource) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Viewed", {
            "Page Source": pageSource
        });
    },
    onUserProfileChatSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Chat Selected");
    },
    onUserProfileFollowSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Follow Selected");
    },
    onUserProfileUnfollowSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Unfollow Selected");
    },
    onUserProfileTurnOnAlert: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Turn On Alert");
    },
    onUserProfileComposePost: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Compose Post");
    },
    onUserProfileAddorRemovefromWatchlist: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Add or Remove from Watchlist");
    },
    onUserProfileBlock: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Block");
    },
    onUserProfileSuccessfullyTurnOnAlert: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Successfully Turn on alert");
    },
    onComposePostViewed: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Compose Post Viewed");
    },
    onUserProfileAddOrRemoveFromWatchlistViewed: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Add or Remove from Watchlist Viewed");
    },
    onUserProfileBlockConfirmed: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Block Confirmed");
    },
    onUserProfileSuccessfullyBlocked: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Successfully Blocked");
    },
    onUserProfileTurnOffAlert: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Turn Off Alert");
    },
    onUserProfileSuccessfullyTurnOffAlert: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Successfully Turn Off Alert");
    },
    onUserProfileUnblock: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Unblock");
    },
    onUserProfileUnblockConfirmed: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Unblock Confirmed");
    },
    onUserProfileSuccessfullyUnblocked: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Successfully Unblock");
    }
};


/***/ }),

/***/ 3897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export isElementTypeOf */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var isElementTypeOf = function(target, element) {
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(target) && target.type === element;
};
var Else = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
var If = function(props) {
    var condition = props.condition, children = props.children;
    if (condition) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children).filter(function(child) {
                return !isElementTypeOf(child, Else);
            })
        });
    }
    return react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, function(child) {
        if (isElementTypeOf(child, Else)) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child);
        }
        return null;
    });
};
If.Else = Else;
/* harmony default export */ __webpack_exports__["Z"] = (If);


/***/ }),

/***/ 14467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12902);




var initialState = {
    activeModal: undefined,
    modalProps: {}
};
var useGlobalModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setActiveModal: function(activeModal, props) {
            set({
                activeModal: activeModal
            });
            if (activeModal) {
                get().setModalProps(activeModal, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props), {
                    onCancel: function() {
                        if (!(props === null || props === void 0 ? void 0 : props.preventClose)) get().setActiveModal();
                        if (props === null || props === void 0 ? void 0 : props.onCancel) props.onCancel();
                    }
                }));
            }
        },
        setModalProps: function(type, props) {
            set((0,immer__WEBPACK_IMPORTED_MODULE_3__/* .produce */ .Uy)(function(state) {
                state.modalProps[type] = props;
            }));
        },
        resetActiveModal: function() {
            return set({
                activeModal: undefined
            });
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useGlobalModalStore);


/***/ }),

/***/ 30682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ GlobalModalType; }
/* harmony export */ });
var GlobalModalType;
(function(GlobalModalType) {
    GlobalModalType["FastOrder"] = "fastOrder";
    GlobalModalType["ChatLimit"] = "chatLimit";
})(GlobalModalType || (GlobalModalType = {}));


/***/ }),

/***/ 37842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _deprecated_ui_common_Tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39211);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(579);
/* harmony import */ var lib_api_verifiedBadge__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79644);







var URL_VERIFICATION_ARTICLE = "https://help.stockbit.com/id/article/bagaimana-cara-mengajukan-verifikasi-akun-stockbit-6omqkl/";
function GreenVerifiedBadge() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        placement: "right",
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: "12px",
            color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light,
            padding: "6px 6px",
            height: "18px",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    as: "span",
                    family: "bold",
                    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light,
                    size: "12px",
                    children: "Verified Account"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                "Stockbit sudah mengkonfirmasi keaslian dan kelayakan akun ini.\xa0",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: URL_VERIFICATION_ARTICLE,
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    target: "_blank",
                    rel: "noreferrer noopener",
                    children: "Pelajari Lebih Lanjut"
                })
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            src: "/icon/widget-trending/icon-verified.svg",
            style: {
                width: "12px",
                marginLeft: 5
            },
            alt: "icon-verified"
        })
    });
}
function GreyVerifiedBadge() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        placement: "right",
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: "12px",
            color: "#858585",
            padding: "6px 6px",
            height: "18px",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    as: "span",
                    family: "bold",
                    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light,
                    size: "12px",
                    children: "Account Verified"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                "Identitas user telah terverifikasi sebagai nasabah Stockbit Sekuritas"
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            src: "/icon/verified-grey.svg",
            style: {
                width: "12px",
                marginLeft: 4
            },
            alt: "icon-verified"
        })
    });
}
function LabelVerifiedAccount(param) {
    var deprecatedVerifiedStatus = param.deprecatedVerifiedStatus, verifiedStatus = param.verifiedStatus;
    if (verifiedStatus === lib_api_verifiedBadge__WEBPACK_IMPORTED_MODULE_6__/* .VerifiedStatus.VERIFIED_STATUS_COMMUNITY */ .P.VERIFIED_STATUS_COMMUNITY) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GreenVerifiedBadge, {});
    }
    if (verifiedStatus === lib_api_verifiedBadge__WEBPACK_IMPORTED_MODULE_6__/* .VerifiedStatus.VERIFIED_STATUS_IDENTITY */ .P.VERIFIED_STATUS_IDENTITY) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GreyVerifiedBadge, {});
    }
    if (deprecatedVerifiedStatus && verifiedStatus === undefined) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GreenVerifiedBadge, {});
    }
    return null;
}
/* harmony default export */ __webpack_exports__["Z"] = (LabelVerifiedAccount);


/***/ }),

/***/ 94493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SH": function() { return /* reexport */ Labels_LabelAdmin; },
  "QP": function() { return /* reexport */ Labels_LabelTopUser; },
  "uC": function() { return /* reexport */ LabelVerifiedAccount/* default */.Z; }
});

// UNUSED EXPORTS: LabelPro, LabelSuspended, LabelVerified

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var common_Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var common_Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var _style_color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/utils/userRole.js
var userRole = __webpack_require__(58080);
;// CONCATENATED MODULE: ./src/global/Labels/LabelAdmin.tsx





function LabelAdmin(param) {
    var privilege = param.privilege;
    if ((0,userRole/* getUserRole */.Rg)(privilege)) {
        return(// @ts-expect-error
        /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Button/* default */.Z, {
            p: "0px",
            margin: "0 2px",
            round: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                size: "10px",
                color: _style_color/* default.suvaGrey */.Z.suvaGrey,
                padding: "2px",
                children: (0,userRole/* getUserRole */.Rg)(privilege)
            })
        }));
    }
    return null;
}
/* harmony default export */ var Labels_LabelAdmin = (LabelAdmin);

;// CONCATENATED MODULE: ./src/global/Labels/LabelPro.tsx




function LabelPro() {
    return(// @ts-expect-error
    /*#__PURE__*/ _jsx(Button, {
        p: "0px",
        margin: "0 2px",
        round: true,
        children: /*#__PURE__*/ _jsx(Text, {
            size: "10px",
            color: color.suvaGrey,
            padding: "2px",
            children: "PRO"
        })
    }));
}
/* harmony default export */ var Labels_LabelPro = ((/* unused pure expression or super */ null && (LabelPro)));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tag.js
var Tag = __webpack_require__(12484);
;// CONCATENATED MODULE: ./src/global/Labels/LabelSuspended.tsx



var LabelSuspended_Tag = Tag/* default.Tag */.Z.Tag;
function LabelSuspended() {
    return /*#__PURE__*/ _jsx(LabelSuspended_Tag, {
        style: {
            borderColor: color.sunsetOrange,
            color: color.sunsetOrange,
            fontWeight: "bold"
        },
        children: "Suspended"
    });
}
/* harmony default export */ var Labels_LabelSuspended = ((/* unused pure expression or super */ null && (LabelSuspended)));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tooltip.js
var common_Tooltip = __webpack_require__(39211);
;// CONCATENATED MODULE: ./src/global/Labels/LabelTopUser.tsx





function LabelTopUser() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Tooltip/* default */.Z, {
        placement: "right",
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Stockbit top users"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Button/* default */.Z, {
            p: "0px",
            margin: "0 2px",
            round: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                size: "10px",
                color: _style_color/* default.suvaGrey */.Z.suvaGrey,
                padding: "2px",
                children: "TOP"
            })
        })
    });
}
/* harmony default export */ var Labels_LabelTopUser = (LabelTopUser);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var common_Iconmoon = __webpack_require__(15807);
;// CONCATENATED MODULE: ./src/global/Labels/LabelVerified.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable react/jsx-wrap-multilines */ 




var URL_VERIFICATION_ARTICLE = "https://help.stockbit.com/id/article/bagaimana-cara-mengajukan-verifikasi-akun-stockbit-6omqkl/";
function LabelVerified() {
    return /*#__PURE__*/ _jsx(Tooltip, {
        placement: "rightTop",
        autoAdjustOverflow: true,
        overlayInnerStyle: {
            background: "rgba(64, 64, 64, 0.85)"
        },
        title: /*#__PURE__*/ _jsxs("p", {
            style: {
                marginBottom: 0
            },
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    family: "bold",
                    color: color.light,
                    size: "12px",
                    style: {
                        lineHeight: "1.5"
                    },
                    children: "Verified Account"
                }),
                /*#__PURE__*/ _jsxs(Text, {
                    color: color.light,
                    size: "12px",
                    height: "1.5",
                    children: [
                        "Stockbit sudah mengkonfirmasi keaslian dan kelayakan akun ini.",
                        " ",
                        /*#__PURE__*/ _jsx("span", {
                            style: {
                                color: color.primary,
                                cursor: "pointer"
                            },
                            onClick: function() {
                                return window.open(URL_VERIFICATION_ARTICLE);
                            },
                            children: "Pelajari Lebih Lanjut"
                        })
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ _jsx(IconWrapper, {
            padding: "0 4px",
            children: /*#__PURE__*/ _jsx(Iconmoon, {
                className: "icon-custom_verified-circle",
                size: "12px",
                color: color.primary
            })
        })
    });
}
/* harmony default export */ var Labels_LabelVerified = ((/* unused pure expression or super */ null && (LabelVerified)));

// EXTERNAL MODULE: ./src/global/Labels/LabelVerifiedAccount.tsx
var LabelVerifiedAccount = __webpack_require__(37842);
;// CONCATENATED MODULE: ./src/global/Labels/index.tsx








/***/ }),

/***/ 37489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ EVENT_STATUS; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var EVENT_STATUS = {
    UPCOMING: "EVENT_STATUS_UPCOMING",
    LIVE: "EVENT_STATUS_LIVE",
    ENDED: "EVENT_STATUS_ENDED"
};


/***/ }),

/***/ 32447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95541);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29658);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @keyframes rotate {\n    0% {\n      transform: rotate(0deg);\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.8;\n    }\n    100% {\n      transform: rotate(360deg);\n      opacity: 1;\n    }\n  }\n\n  > div {\n    display: block;\n    margin: auto;\n    height: ",
        ";\n    width: ",
        ";\n    animation: rotate 0.8s infinite linear;\n    border-radius: 50%;\n    border: solid 1.5px ",
        ";\n    border-right-color: transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





// eslint-disable-next-line space-infix-ops
var SecondarySpinnerDiv = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bfa5182-0"
})(_templateObject(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) || "18px";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) || "18px";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.color) || "#6b6b6b";
});
var SecondarySpinner = function(_param) /*#__PURE__*/ {
    var _size = _param.size, size = _size === void 0 ? "18px" : _size, text = _param.text, _color = _param.color, color = _color === void 0 ? "#6b6b6b" : _color, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "size",
        "text",
        "color",
        "isLoading"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            direction: "column",
            justify: "center",
            align: "center"
        }, props), {
            "data-cy": "global-loading-spinner-container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SecondarySpinnerDiv, {
                    size: size,
                    color: color,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    condition: text,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        family: "light",
                        padding: "20px 0 0 0",
                        children: text
                    })
                })
            ]
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SecondarySpinner);


/***/ }),

/***/ 64924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IE": function() { return /* binding */ getBondPortfolioDetail; },
/* harmony export */   "OF": function() { return /* binding */ postBondSell; },
/* harmony export */   "QY": function() { return /* binding */ getBondSellPreview; },
/* harmony export */   "R0": function() { return /* binding */ getBondOrderList; },
/* harmony export */   "UU": function() { return /* binding */ getBondBuyPreview; },
/* harmony export */   "iC": function() { return /* binding */ getBondOrderDetail; },
/* harmony export */   "yr": function() { return /* binding */ getBondPortfolioList; },
/* harmony export */   "yt": function() { return /* binding */ postBondBuy; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53850);
/* harmony import */ var _instance_trading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96563);




var postBondBuy = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(form) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.postBuy */ .EN.postBuy, form));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postBondBuy(form) {
        return _ref.apply(this, arguments);
    };
}();
var getBondBuyPreview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getBuyPreview */ .EN.getBuyPreview, {
                        params: params
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondBuyPreview(params) {
        return _ref.apply(this, arguments);
    };
}();
var postBondSell = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(form) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.postSell */ .EN.postSell, form));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postBondSell(form) {
        return _ref.apply(this, arguments);
    };
}();
var getBondSellPreview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getSellPreview */ .EN.getSellPreview, {
                        params: params
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondSellPreview(params) {
        return _ref.apply(this, arguments);
    };
}();
var getBondOrderList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getOrderList */ .EN.getOrderList));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondOrderList() {
        return _ref.apply(this, arguments);
    };
}();
var getBondOrderDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getOrderDetail */ .EN.getOrderDetail(orderId)));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondOrderDetail(orderId) {
        return _ref.apply(this, arguments);
    };
}();
var getBondPortfolioList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getPortfolioList */ .EN.getPortfolioList));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondPortfolioList() {
        return _ref.apply(this, arguments);
    };
}();
var getBondPortfolioDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
        var withCouponHistories, _args = arguments;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    withCouponHistories = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getPortfolioDetail */ .EN.getPortfolioDetail(orderId), {
                        params: {
                            with_coupon_histories: withCouponHistories ? 1 : 0
                        }
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondPortfolioDetail(orderId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 96563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ tradingApiInstance; },
/* harmony export */   "j": function() { return /* binding */ getTradingApiInstance; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48884);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83153);
/* harmony import */ var features_securities_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4621);





var _obj;
var tradingApiInstance = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .UserTargetAPI.LEGACY */ .FA.LEGACY, (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL */ .Cb, false, false)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .UserTargetAPI.NEW_CORE */ .FA.NEW_CORE, (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, false, false)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "general", (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg)), _obj);
var getTradingApiInstance = function() {
    var targetAPI = (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTargetAPI */ .Ai)();
    return tradingApiInstance[targetAPI];
};


/***/ }),

/***/ 38525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ withMaintenanceGuard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/lib/stores/trading.ts
var trading = __webpack_require__(76260);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/trading.ts
var instance_trading = __webpack_require__(96563);
;// CONCATENATED MODULE: ./src/global/Securities/api/maintenance.ts




var getMaintenanceStatus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,instance_trading/* getTradingApiInstance */.j)().get(apiEndpoint/* maintenanceEndpoint.getStatus */.bB.getStatus, {
                        withAccessToken: false
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getMaintenanceStatus() {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/global/Securities/types/api/maintenance.ts
var MaintenanceStatusType;
(function(MaintenanceStatusType) {
    MaintenanceStatusType["Unspecified"] = "STATUS_UNSPECIFIED";
    MaintenanceStatusType["OnMaintenance"] = "STATUS_MAINTENANCE";
    MaintenanceStatusType["NotMaintenance"] = "STATUS_NOT_MAINTENANCE";
})(MaintenanceStatusType || (MaintenanceStatusType = {}));

;// CONCATENATED MODULE: ./src/global/Securities/utils/maintenance.ts





// Modify the function signature to accept arguments
function withMaintenanceGuard(// eslint-disable-next-line @typescript-eslint/ban-types
callback) {
    return _withMaintenanceGuard.apply(this, arguments);
}
function _withMaintenanceGuard() {
    _withMaintenanceGuard = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(callback) {
        var isAllowed, response, _data, data, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    isAllowed = false;
                    if (isAllowed) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return", callback());
                case 4:
                    _ctx.next = 6;
                    return getMaintenanceStatus();
                case 6:
                    response = _ctx.sent;
                    _data = response.data, data = _data.data, message = _data.message;
                    if (!(data.status === MaintenanceStatusType.OnMaintenance)) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", trading/* default.getState */.Z.getState().setErrorCode(503, message, "DAILY_MAINTENANCE_MODE"));
                case 10:
                    return _ctx.abrupt("return", callback());
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", callback());
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return _withMaintenanceGuard.apply(this, arguments);
}


/***/ }),

/***/ 29176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBondPortfolioStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);
/* harmony import */ var utils_securities_transformData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75413);








var initialState = {
    detailBySymbol: undefined,
    details: undefined,
    portfolios: [],
    bondPortfolioState: [],
    transactions: [],
    product: undefined,
    couponHistories: undefined,
    isLoading: false,
    isLoadingList: false
};
var useBondPortfolioStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadPortfolioList: function loadPortfolioList() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data, portfolios, rest;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoadingList: true
                            });
                            _ctx.next = 4;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondPortfolioList */ .yr)();
                        case 4:
                            response = _ctx.sent;
                            data = response.data.data;
                            portfolios = data.portfolios, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data, [
                                "portfolios"
                            ]);
                            set({
                                portfolios: portfolios,
                                bondPortfolioState: portfolios.map(utils_securities_transformData__WEBPACK_IMPORTED_MODULE_2__/* ["default"].portfolioItemFromBonds */ .Z.portfolioItemFromBonds),
                                details: rest,
                                isLoadingList: false
                            });
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoadingList: false,
                                portfolios: initialState.portfolios,
                                details: initialState.details,
                                bondPortfolioState: initialState.bondPortfolioState
                            });
                            Promise.reject(_ctx.t0);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }))();
        },
        loadPortfolioDetails: function loadPortfolioDetails(id) {
            var withCouponHistories = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data, transactions, coupon_histories, product, rest;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondPortfolioDetail */ .IE)(id, withCouponHistories);
                        case 4:
                            response = _ctx.sent;
                            data = response.data.data;
                            transactions = data.transactions, coupon_histories = data.coupon_histories, product = data.product, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data, [
                                "transactions",
                                "coupon_histories",
                                "product"
                            ]);
                            set({
                                transactions: transactions,
                                product: product,
                                couponHistories: coupon_histories,
                                detailBySymbol: rest,
                                isLoading: false
                            });
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }))();
        },
        clear: function clear() {
            set(initialState);
        },
        clearPortfolioList: function clearPortfolioList() {
            set({
                portfolios: initialState.portfolios,
                transactions: initialState.transactions,
                product: initialState.product
            });
        },
        clearAssets: function clearAssets() {
            set({
                transactions: initialState.transactions,
                detailBySymbol: initialState.detailBySymbol
            });
        }
    });
});


/***/ }),

/***/ 71534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var features_chat_constant__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52288);
/* harmony import */ var lib_api_chat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69101);
/* harmony import */ var global_GlobalModalManager_stores_useGlobalModalStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14467);
/* harmony import */ var global_GlobalModalManager_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30682);
/* harmony import */ var features_user_analytics_ProfileAnalytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63576);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86123);
/* harmony import */ var config_requestTrading_errorHandler__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22537);














function useChat() {
    var source = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    var setActiveModal = (0,global_GlobalModalManager_stores_useGlobalModalStore__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(s) {
        return s.setActiveModal;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), fetchingEligibility = ref[0], setFetchingEligibility = ref[1];
    var checkEligibility = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(uname, showLoading) {
            var eligibility;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (showLoading) setFetchingEligibility(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,lib_api_chat__WEBPACK_IMPORTED_MODULE_4__/* .getChatEligibility */ .r4)(uname);
                    case 4:
                        eligibility = _ctx.sent;
                        if (showLoading) setFetchingEligibility(false);
                        return _ctx.abrupt("return", eligibility.data.data.is_eligible);
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](1);
                        (0,config_requestTrading_errorHandler__WEBPACK_IMPORTED_MODULE_10__/* .handleShowAlertMessage */ .Ye)(_ctx.t0);
                        return _ctx.abrupt("return", true);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    9
                ]
            ]);
        }));
        return function checkEligibility(uname, showLoading) {
            return _ref.apply(this, arguments);
        };
    }();
    var redirectChat = function(uname, target) {
        var q = {};
        if (uname) {
            q = {
                n: uname
            };
        }
        if (source === "main-profile") {
            q = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, q), {
                source: features_chat_constant__WEBPACK_IMPORTED_MODULE_3__/* .SOURCE_CHAT_ROOM_VIEWED.findIndex */ .VY.findIndex(function(item) {
                    return item === "User Profile";
                })
            });
        }
        var query = qs__WEBPACK_IMPORTED_MODULE_2___default().stringify(q);
        query = query ? "?".concat(query) : "";
        if (target === "_self") {
            router.push("/chat".concat(query));
        } else {
            window.open("".concat(constants_app__WEBPACK_IMPORTED_MODULE_9__/* .PROJECT_FOLDER_PATH */ .qV, "/chat").concat(query), target);
        }
    };
    var openChatLimit = function() {
        setActiveModal(global_GlobalModalManager_types__WEBPACK_IMPORTED_MODULE_6__/* .GlobalModalType.ChatLimit */ .C.ChatLimit);
    };
    var openChat = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(props) {
            var username, _target, target, onEligible, onIneligible, is_eligible;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        username = props.username, _target = props.target, target = _target === void 0 ? "_blank" : _target, onEligible = props.onEligible, onIneligible = props.onIneligible;
                        setFetchingEligibility(true);
                        if (source === "main-profile") {
                            features_user_analytics_ProfileAnalytics__WEBPACK_IMPORTED_MODULE_7__/* .mainProfileEvents.onUserProfileChatSelected */ .j4.onUserProfileChatSelected();
                        }
                        _ctx.next = 5;
                        return checkEligibility(username);
                    case 5:
                        is_eligible = _ctx.sent;
                        setFetchingEligibility(false);
                        if (is_eligible) {
                            onEligible === null || onEligible === void 0 ? void 0 : onEligible();
                            redirectChat(username, target);
                        } else {
                            onIneligible === null || onIneligible === void 0 ? void 0 : onIneligible();
                            openChatLimit();
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function openChat(props) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        isFetching: fetchingEligibility,
        openChat: openChat,
        checkEligibility: checkEligibility,
        redirectChat: redirectChat,
        openChatLimit: openChatLimit
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useChat);


/***/ }),

/***/ 97486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useDebounce(value, delay) {
    // State and setters for debounced value
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // Update debounced value after delay
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return function() {
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
/* harmony default export */ __webpack_exports__["Z"] = (useDebounce);


/***/ }),

/***/ 64999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71158);
/* harmony import */ var global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20620);


var useTradingAccount = function() {
    var tradingType = (0,global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(s) {
        return s.accountType;
    });
    var isRealTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.REAL */ .Q5.REAL;
    var isVirtualTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.VIRTUAL */ .Q5.VIRTUAL;
    return {
        tradingType: tradingType,
        isRealTrading: isRealTrading,
        isVirtualTrading: isVirtualTrading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTradingAccount);


/***/ }),

/***/ 61942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ entities_livestream; },
  "Sz": function() { return /* binding */ effects; },
  "wl": function() { return /* binding */ selectors; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/lib/api/livestream.ts
/* eslint-disable import/named */ /** @typedef {import('../../../@types/api-response').APIResponse} APIResponse */ 

var request = (0,requestExodus/* default */.Z)();
var LIVE_STREAM_URL = "".concat(api/* API_EXODUS_URL */.q7, "/live-stream");
/**
 * Get Livestreams Event List
 * @param { Object } params
 * @param {number=} params.page
 * @param {string=} params.limit
 * @param {string=} params.status
 * @returns {APIResponse}
 */ var getEventList = function(params) {
    return request.get("".concat(LIVE_STREAM_URL, "/event"), {
        params: params
    });
};
/**
 * Get Livestream Event
 * @param {string|number=} id
 * @returns {APIResponse}
 */ var getEvent = function(id) {
    return request.get("".concat(LIVE_STREAM_URL, "/event/").concat(id));
};
/**
 * Write Question
 * @param { Object } params
 * @param {number=} params.id
 * @param {string=} params.question
 * @returns {APIResponse}
 */ var writeQuestion = function(params) {
    return request.post("".concat(LIVE_STREAM_URL, "/event/").concat(params.id, "/question"), {
        question: params.question
    });
};
/**
 * Get Nont Login Livestream Event
 * @param {string|number=} id
 * @returns {APIResponse}
 */ var getEventNonLogin = function(id) {
    return request.get("".concat(LIVE_STREAM_URL, "/non-login/event/").concat(id));
};
/* harmony default export */ var livestream = ({
    getEventList: getEventList,
    getEvent: getEvent,
    writeQuestion: writeQuestion,
    getEventNonLogin: getEventNonLogin
});

;// CONCATENATED MODULE: ./src/lib/entities/livestream.ts








/**
 * Note for event filtered data Schema
 * because we pass status as argument, we will use that as key to save the response
 * the schema will look like this
 *
 * data[eventStatus]: [
 *   { ... }
 * ]
 */ var initialState = {
    eventList: {
        data: [],
        isLoading: false,
        message: "",
        error: ""
    },
    eventFiltered: {
        data: {},
        isLoading: false,
        isLoadingMore: false,
        hasMore: false,
        message: "",
        error: ""
    },
    event: {
        data: null,
        isLoading: false,
        message: "",
        error: ""
    },
    writeQuestion: {
        data: null,
        isLoading: false,
        message: "",
        error: ""
    }
};
var liveStream = function(state) {
    return state.liveStream;
};
var selectors = (0,es/* createSelector */.P1)(liveStream, function(liveStreamState) {
    return {
        events: liveStreamState.eventList,
        event: liveStreamState.event,
        eventFiltered: liveStreamState.eventFiltered,
        writeQuestions: liveStreamState.writeQuestion
    };
});
var CONTEXT = "@feature/livestream";
var actionType = {
    GET_EVENTS: "".concat(CONTEXT, "/GET_EVENTS"),
    GET_EVENTS_FILTERED: "".concat(CONTEXT, "/GET_EVENTS_FILTERED"),
    GET_EVENT: "".concat(CONTEXT, "/GET_EVENT"),
    WRITE_QUESTION: "".concat(CONTEXT, "/WRITE_QUESTION")
};
var effects = {
    getEventList: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_EVENTS, // @ts-ignore
    (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getEventList({
                        page: 1,
                        limit: 20
                    });
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Failed to get event list");
                case 6:
                    _data = response.data, data = _data.data, message = _data.message;
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getEvent: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_EVENT, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(props) {
            var response, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return getEvent(props);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Failed to get event list");
                    case 6:
                        _data = response.data, data = _data.data, message = _data.message;
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }()),
    getEventListFiltered: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_EVENTS_FILTERED, function() {
        var _ref = // @ts-ignore
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(props) {
            var _page, page, _limit, limit, status, response, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _page = props.page, page = _page === void 0 ? 1 : _page, _limit = props.limit, limit = _limit === void 0 ? 16 : _limit, status = props.status;
                        _ctx.next = 4;
                        return getEventList({
                            page: page,
                            limit: limit,
                            status: status
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Failed to get event list");
                    case 7:
                        _data = response.data, data = _data.data, message = _data.message;
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        }));
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }()),
    writeQuestion: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.WRITE_QUESTION, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(props) {
            var response, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return writeQuestion(props);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Failed to get event list");
                    case 6:
                        _data = response.data, data = _data.data, message = _data.message;
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }())
};
var extraReducers = function(builder) {
    builder.addCase(effects.getEventList.pending, function(state) {
        state.eventList.isLoading = true;
        state.eventList.error = null;
    }).addCase(effects.getEventList.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.eventList.error = error;
        } else {
            state.eventList.data = data;
        }
        state.eventList.message = message;
        state.eventList.isLoading = false;
    }).addCase(effects.getEventList.rejected, function(state, action) {
        state.eventList.isLoading = false;
        state.eventList.error = action.payload.error;
    }).addCase(effects.getEvent.pending, function(state) {
        state.event.isLoading = true;
        state.event.error = null;
    }).addCase(effects.getEvent.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.event.error = error;
        } else {
            state.event.data = data;
        }
        state.event.message = message;
        state.event.isLoading = false;
    }).addCase(effects.getEvent.rejected, function(state, action) {
        state.event.isLoading = false;
        state.event.error = action.payload.error;
    }).addCase(effects.writeQuestion.pending, function(state) {
        state.writeQuestion.isLoading = true;
        state.writeQuestion.error = null;
    }).addCase(effects.writeQuestion.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.writeQuestion.error = error;
        } else {
            state.writeQuestion.data = data;
        }
        state.writeQuestion.message = message;
        state.writeQuestion.isLoading = false;
    }).addCase(effects.writeQuestion.rejected, function(state, action) {
        state.writeQuestion.isLoading = false;
        state.writeQuestion.error = action.payload.error;
    }).addCase(effects.getEventListFiltered.pending, function(state, action) {
        var page = action.meta.arg.page;
        state.eventFiltered.error = null;
        if (page > 1) {
            state.eventFiltered.isLoadingMore = true;
        } else {
            state.eventFiltered.isLoading = true;
        }
    }).addCase(effects.getEventListFiltered.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        var _arg = action.meta.arg, page = _arg.page, status = _arg.status;
        if (error) {
            state.eventFiltered.error = error;
        } else {
            if (page > 1) {
                state.eventFiltered.data = (0,_define_property/* default */.Z)({}, status, (0,_to_consumable_array/* default */.Z)(state.eventFiltered.data[status]).concat((0,_to_consumable_array/* default */.Z)(data)));
                state.eventFiltered.isLoadingMore = false;
            } else {
                state.eventFiltered.data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.eventFiltered.data), (0,_define_property/* default */.Z)({}, status, data));
                state.eventFiltered.isLoading = false;
            }
            if (data.length === 16) {
                state.eventFiltered.hasMore = true;
            } else {
                state.eventFiltered.hasMore = false;
            }
        }
        state.eventFiltered.message = message;
    }).addCase(effects.getEventListFiltered.rejected, function(state, action) {
        state.eventFiltered.isLoading = false;
        state.eventFiltered.error = action.payload.error;
    });
};
var liveStreamSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "livestream",
    initialState: initialState,
    reducers: {},
    extraReducers: extraReducers
});
/* harmony default export */ var entities_livestream = (liveStreamSlice);


/***/ }),

/***/ 42826:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * Upload image handler
 * @param file - File to be uploaded
 * @param url - AWS Bucket URL
 * @param awsFields - Additional aws fields from `getPolicy` API
 * @param - type upload chat|stream
 * @returns {Promise<*>} fetch function
 */ var uploadHandler = function(file, url, awsFields, type) {
    return new Promise(function(resolve, reject) {
        var fd = new FormData();
        var formerFile = null;
        // eslint-disable-next-line no-underscore-dangle
        if (file._file) formerFile = file._file;
        // eslint-disable-next-line array-callback-return
        if (type === "chat") {
            awsFields.map(function(field) {
                return fd.append(field.name, field.value);
            });
        } else if (type === "stream") {
            awsFields.map(function(field) {
                return fd.append(field.key, field.value);
            });
        }
        if (!formerFile) {
            fd.append("file", file);
        } else {
            fd.append("file", formerFile);
        }
        return fetch(url, {
            method: "POST",
            cache: "default",
            body: fd,
            mode: "no-cors"
        }).then(function(response) {
            resolve(response.ok);
        }).catch(function(error) {
            reject(new Error(error));
        });
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (uploadHandler);


/***/ }),

/***/ 58080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AR": function() { return /* binding */ isAllowedToBlockIp; },
/* harmony export */   "Rg": function() { return /* binding */ getUserRole; },
/* harmony export */   "_W": function() { return /* binding */ isAllowedToManageTop; },
/* harmony export */   "w1": function() { return /* binding */ isAllowedToSuspend; },
/* harmony export */   "xj": function() { return /* binding */ UserRoleName; }
/* harmony export */ });
/* unused harmony exports isAllowedToDelete, isAllowedToMultiDelete */
var UserRole = [
    "MEMBER",
    "ADMIN",
    "MODERATOR",
    "CONFIGURATOR",
    "SUPER_ADMIN", 
];
var UserRoleName = {
    MEMBER: "Member",
    ADMIN: "ADMIN",
    MODERATOR: "ADMIN",
    CONFIGURATOR: "CONFIGURATOR",
    SUPER_ADMIN: "ADMIN"
};
var checkPrivilege = function(userPriv, allowed) {
    return allowed.indexOf("".concat(userPriv)) >= 0;
};
var isAllowedToDelete = function(userPriv) {
    return checkPrivilege(userPriv, [
        "1",
        "2",
        "4"
    ]);
};
var isAllowedToMultiDelete = function(userPriv) {
    return checkPrivilege(userPriv, [
        "1",
        "2",
        "4"
    ]);
};
var isAllowedToSuspend = function(userPriv) {
    return checkPrivilege(userPriv, [
        "1",
        "2",
        "4"
    ]);
};
var isAllowedToBlockIp = function(userPriv) {
    return checkPrivilege(userPriv, [
        "4"
    ]);
};
var isAllowedToManageTop = function(userPriv) {
    return checkPrivilege(userPriv, [
        "1",
        "4"
    ]);
};
var getUserRole = function(userPriv) {
    if (!checkPrivilege(userPriv, [
        "1",
        "2",
        "4"
    ])) {
        return "";
    }
    var role = UserRole[userPriv];
    return UserRoleName[role];
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (UserRole)));


/***/ })

}]);